import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.QBooksBillFields', {
    mailingAddressFieldTitle: 'Mailing Address',
    billTermsFieldTitle: 'Terms',
    billDateFieldTitle: 'Bill date',
    billDueDateFieldTitle: 'Due date',
    billNumberFieldTitle: 'Bill number',
});
